import { render, staticRenderFns } from "./RightsManagementIndex.vue?vue&type=template&id=6b36f840&scoped=true&"
import script from "./RightsManagementIndex.vue?vue&type=script&lang=js&"
export * from "./RightsManagementIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36f840",
  null
  
)

export default component.exports